//import packages from node modules
import React from 'react'
import { Redirect } from 'react-router-dom'


//import shared utility functions
import { DOMAIN_TYPE, GSUITE_TYPE, SHARED_HOSTING_TYPE, VPS_TYPE } from './servicetype'
import {
  CUSTOM_HOSTING_FLOW,
  EMAIL_HOSTING_FLOW,
  GSUITE_FLOW,
  SSL_FLOW,
  VPS_FLOW,
  WEB_HOSTING_FLOW
} from './productFlow'

import {
  getDomainNamePayloadFromConfig,
  getServiceTypeFromProductConfig,
  getProductLabel,
  getAttributes,
  getOrderingFlowType,
  getFilteredConfigurationList
} from './configuration'

import {
  getPriceByBillingCycleID,
  getCycle
} from './billingCycle'

import { domainnameFieldValidation } from '../../components/shared/form/validation'

//import shared components

import Ellipsis from "../../components/shared/ellipsis"

import WebHosting from '../../components/pages/webhosting'
import CustomHosting from '../../components/pages/customhosting'
import VPS from '../../components/pages/vps'
import GSuite from '../../components/pages/gsuite'
import EmailHosting from '../../components/pages/emailhosting'
import SSL from '../../components/pages/ssl'

import { CartBillingCycleDropdown, EditOptions } from '../../components/shared/cart'

import {renderPrice,renderIcon} from '../../components/shared/cart'


export const DATE_FORMAT = 'DD-MM-YYYY'

export const getAddedConfigurations = (configurations,productInformation,items) => {
  let addedConfigurations = {}
  items.forEach(item => {
    const { uuid, id, billing_cycle_id, addons, name, config,quantity } = item
    const selectedProduct = productInformation.find(item => item.id === id)
    if (selectedProduct && configurations && selectedProduct.attributes) {
      const { service_type } = selectedProduct.attributes
      const getBreadCrumbs = () => {
        if (configurations[uuid] && configurations[uuid].breadcrumbs) {
          return configurations[uuid].breadcrumbs
        }
        return []
      }
      if(service_type===DOMAIN_TYPE){
        addedConfigurations[uuid] = {
          ...item,
          selectedProduct,
          breadcrumbs: getBreadCrumbs(),
          step: 0
        }
      }else{
        addedConfigurations[uuid] = {
          selectedProduct,
          breadcrumbs: getBreadCrumbs(),
          step: 0,
          billing_cycle_id,
          name,
          uuid
        }
        if(service_type === SHARED_HOSTING_TYPE || service_type=== GSUITE_TYPE){
          addedConfigurations[uuid] = {
            ...addedConfigurations[uuid],
            isNewDomainName: false,
            isTransferMode: false
          }
        }
        if(addons && addons.length > 0){
          addedConfigurations[uuid] = {
            ...addedConfigurations[uuid],
            addons
          }
        }
        if(config && config.length > 0){
          addedConfigurations[uuid] = {
            ...addedConfigurations[uuid],
            config
          }
        }
        if(quantity){
          addedConfigurations[uuid] = {
            ...addedConfigurations[uuid],
            quantity
          }
        }
      }
    }
  })
  return addedConfigurations
}

export const manageOrderingProductFlow = (productid) =>{
  const orderingFlowType = getOrderingFlowType(productid)
  if(orderingFlowType!==DOMAIN_TYPE){
    switch (orderingFlowType){
      case WEB_HOSTING_FLOW:
        return (<WebHosting />)
      case CUSTOM_HOSTING_FLOW:
        return (<CustomHosting />)
      case VPS_FLOW:
        return (<VPS/>)
      case GSUITE_FLOW:
        return (<GSuite/>)
      case EMAIL_HOSTING_FLOW:
        return (
          <EmailHosting />
        )
      case SSL_FLOW:
        return (<SSL />)

      default:
        return (<Redirect to={window.location.pathname}/>)
    }
  }
}

export const generateProductPayloadConfig = (productConfig, configurations) => {
  const { selectedProduct, billing_cycle_id, name, addons, config,quantity, epp, auto_renew, id_protection, custom_fields } = productConfig || {};
  const { id } = selectedProduct
  const orderingFlowType = getOrderingFlowType(id)
  const getDomainName = () => {
    if (orderingFlowType === WEB_HOSTING_FLOW || orderingFlowType === CUSTOM_HOSTING_FLOW || orderingFlowType===GSUITE_FLOW) {
      if (name && domainnameFieldValidation(name) === undefined) {
        if (epp && configurations[name].order_type === 'transfer') {
          configurations[name].epp = epp
        }
        if (custom_fields != null && configurations[name].order_type === 'register'){ configurations[name].custom_fields = custom_fields}
        if (auto_renew != null ){ configurations[name].auto_renew = auto_renew }
        if (id_protection != null){ configurations[name].id_protection = id_protection }
        return getDomainNamePayloadFromConfig(configurations[name])
      }
    }
    return null
  }
  const getAddons = () => {
    const list = []
    if (addons && addons.length) {
      addons.forEach((item) => {
        const addon = {
          id: item.id,
          billing_cycle_id
        }
        if(addon.id){
          list.push(addon)
        }
      })
    }
    return list
  }
  const getConfigOptions = () => {
    let list = []
    if (config && config.length) {
      config.forEach((item) => {
        const {config_id, option_id} = item
        if(config_id && option_id){
          list.push(item)
        }
      })
    }
    return list
  }
  if (orderingFlowType === WEB_HOSTING_FLOW) {
    const hostingProduct = {
      id,
      billing_cycle_id,
      name,
      addons: getAddons()
    }
    const productList = []
    productList.push(hostingProduct)
    const domainName = getDomainName()
    if (domainName) {
      productList.push(domainName)
    }
    return (productList)
  }
  if (orderingFlowType === CUSTOM_HOSTING_FLOW) {
    const hostingProduct = {
      id,
      billing_cycle_id,
      name,
      addons: getAddons(),
      config: getConfigOptions()
    }
    const productList = []
    productList.push(hostingProduct)
    const domainName = getDomainName()
    if (domainName) {
      productList.push(domainName)
    }
    return (productList)
  }
  if (orderingFlowType === VPS_FLOW) {
    const hostingProduct = {
      id,
      billing_cycle_id,
      name,
      addons: getAddons(),
      config: getConfigOptions()
    }
    const productList = []
    productList.push(hostingProduct)
    return (productList)
  }
  if (orderingFlowType === GSUITE_FLOW) {
    const hostingProduct = {
      id,
      billing_cycle_id,
      name,
      config: getConfigOptions()
    }
    const productList = []
    productList.push(hostingProduct)
    const domainName = getDomainName()
    if (domainName) {
      productList.push(domainName)
    }
    return (productList)
  }
  if (orderingFlowType === EMAIL_HOSTING_FLOW) {
    const hostingProduct = {
      id,
      billing_cycle_id,
      quantity
    }
    const productList = []
    productList.push(hostingProduct)
    return (productList)
  }
  if (orderingFlowType === SSL_FLOW) {
    const hostingProduct = {
      id,
      billing_cycle_id
    }
    const productList = []
    productList.push(hostingProduct)
    return (productList)
  }
  return ([])
}

export const getIconSlugBasedOnServiceType = (productConfig) => {
  let slug ="shared-hosting-common";
  if(productConfig && productConfig.selectedProduct){
    const {id,attributes} = productConfig.selectedProduct
    const {order_type} = productConfig
    if(attributes){
      const {service_type,group} = attributes
      if (service_type ==="domain" && order_type){
        slug = service_type
        if(order_type==="transfer"){
          slug = 'transfer-domain'
        }
      }else{
        const flowType = getOrderingFlowType(id)
        if(flowType===SHARED_HOSTING_TYPE){
          if(group && group.name.indexOf("Smarter")>=0){
            slug = 'shared-hosting'
          }
        }else if(flowType===VPS_TYPE){
          if (flowType && flowType.replace(/_/g, '-')) {
            slug = flowType.replace(/_/g, '-')
          }
          if(group && group.name.indexOf("SELF")>=0){
            slug = 'vps-self'
          }
        }else{
          if (flowType && flowType.replace(/_/g, '-')) {
            slug = flowType.replace(/_/g, '-')
          }
        }
      }
    }
  }
  return slug
}

export const getConfigName = (name) =>{
    let string = name
    if(name){
      string = name.split("|")
      if(string && string.length > 0 && Array.isArray(string)){
        if(string.length===1){
          return name
        }
        return string[1]
      }
    }
    return name
}

export const renderCommonCartItem = (productConfig, cartItem) => {
  if (productConfig && productConfig.selectedProduct && cartItem) {
    const productAttributes = getAttributes(productConfig.selectedProduct)
    const service_type = getServiceTypeFromProductConfig(productConfig)
    const { billing_cycle_id } = productConfig
    const {addons,quantity,item_discount_amount} = cartItem
    const getProductName = () => {
      if (productAttributes) {
        const { name, service_type } = productAttributes
        return getProductLabel(name,service_type)
      }
      return ''
    }
    const getDomainName = () => {
      const { name } = cartItem
      const renderFormat = () =>{
        const first = name.substring(0,10)
        const last = name.substring(name.length-10)
        return(<>{first}...{last}</>)
      }
      if(name){
        return <Ellipsis tooltip={name} format={renderFormat()} isActive={name && name.length > 32}>
          {name}
        </Ellipsis>
      }
      return <></>
    }
    const renderTotal = () => {
      if (productAttributes) {
        const { price } = productAttributes
        if (addons && addons.length) {
          const renderTotalAmount = () => {
            if (price) {
              return (
                <div
                  className={'of-cart-item-total__value total-amount'}>{renderPrice(service_type, cartItem, price, billing_cycle_id, true)}</div>
              )
            }
            return (<></>)
          }
          return (
            <div className={'of-cart-item__wrapper of-cart-item-total'}>
              <div className={'of-cart-item__left'}>
                <div className={'of-cart-item-total__label text-font-1-100'}>Total Cost</div>
              </div>
              <div className={'of-cart-item__right'}>
                {renderTotalAmount()}
                {renderFirstInvoiceInfo(true)}
              </div>
            </div>
          )
        }
      }
      return (<></>)
    }
    const renderConfigs = () => {
      const { config } = cartItem
      if (config && config.length > 0 && productAttributes) {
        const renderOptionItem = () => {
          return config.map((item, index) => {
            const { config_id, option_id,quantity } = item
            const getConfigItemByID = () => {
              const { config_options } = productAttributes
              if (config_options && config_options.length) {
                return config_options.find(i => i.id === config_id)
              }
              return null
            }
            const info = getConfigItemByID()
            if (info) {
              const { name } = info
              const optionInfo = info.options.find(item => item.id === option_id)
              if (optionInfo) {
                const getOptionName = () => {
                  const { name } = optionInfo
                  if(quantity){
                    return quantity + ' '
                  }
                  return getConfigName(name)
                }
                const renderComa = () => {
                  if (index !== config.length - 1) {
                    return (<div className={'of-cart-item-config__coma text-font-3-100'}>,</div>)
                  }
                  return (<></>)
                }
                if(service_type===VPS_TYPE){
                  return (
                    <div key={index} className={'of-cart-item-list-item of-cart-item-config__item'}>
                      <div
                        className='of-cart-item-list-item__label of-cart-item-config__value text-font-1-100'>{name}</div>
                      <div
                        className='of-cart-item-list-item__value of-cart-item-config__label text-font-3-100'>{getOptionName()}</div>
                    </div>
                  )
                }
                return (
                  <div key={index} className={'of-cart-item-list-item of-cart-item-config__item'}>
                    <div
                      className='of-cart-item-list-item__label of-cart-item-config__value text-font-1-100'>{getOptionName()}</div>
                    <div
                      className='of-cart-item-list-item__value of-cart-item-config__label text-font-3-100'>{name}</div>
                    {renderComa()}
                  </div>
                )
              }

            }
            return (<div key={index}/>)
          })
        }
        return (
          <div className={`of-cart-item__wrapper of-cart-item-config of-cart-item-config--${service_type}`}>
            <div className='of-cart-item-list text-font-3-100 of-cart-item-config__list'>
              <div className='of-cart-item-list__heading of-cart-item-config__heading text-font-3-100'>Resources:</div>
              <ul className='of-cart-item-list__list of-cart-item-config__item-list'>
                {renderOptionItem()}
              </ul>
            </div>
          </div>
        )
      }
      return (<></>)
    }
    const renderAddons = () => {
      if (addons && addons.length && productAttributes && productAttributes.addons) {
        const renderAddonItems = () => {
          return addons.map((item, index) => {
            const getAddonItemByID = () => {
              if (productAttributes.addons && productAttributes.addons.length) {
                return productAttributes.addons.find(i => i.id === item.id)
              }
              return null
            }
            const addonInfo = getAddonItemByID()
            if (addonInfo && getAttributes(addonInfo)) {
              const { name, price } = getAttributes(addonInfo)
              return (
                <div key={index} className={'of-cart-item-list-item'}>
                  <div className='of-cart-item-list-item__label text-font-1-100'>{name}</div>
                  <div className='of-cart-item-list-item__price'>
                    {renderPrice(service_type,item, price, billing_cycle_id)}
                  </div>
                </div>
              )
            }
            return ('')
          })
        }
        return (<div className={`of-cart-item__wrapper of-cart-item-addon of-cart-item-addon--${service_type}`}>
          <div className='of-cart-item-list text-font-3-100 of-cart-item-addon__list'>
            <div className='of-cart-item-list__heading text-font-3-100 of-cart-item-addon__heading'>Addons:</div>
            <ul className='of-cart-item-list__list of-cart-item-addon__list-ul'>
              {renderAddonItems()}
            </ul>
          </div>
        </div>)
      }
      return <></>
    }
    const renderQuantity = () => {
      if(productAttributes  && quantity){
        const {is_quantity_based} = productAttributes
        if(is_quantity_based){
          return (<div className={`of-cart-item__wrapper of-cart-item-quantity`}>
            <div className={'of-cart-item-quantity__label text-font-3-100'}>Quantity:</div>
            <div className={'of-cart-item-quantity__value text-font-1-100'}>{quantity}</div>
          </div>)
        }
      }
      return (<></>)
    }
    const renderFirstInvoiceInfo = (bottom=false) =>{
      const {price} = getAttributes(productConfig.selectedProduct)
      const renderText = () =>{
        if(item_discount_amount && parseFloat(item_discount_amount)>0){
          const selectedNormalPrice = getPriceByBillingCycleID(price,billing_cycle_id)
          return (<div className={'of-cart-item-firstinvoice text-font-3-100'}>
            ${selectedNormalPrice.price}{getCycle(selectedNormalPrice.name)} after the first invoice
          </div>)
        }
        return (<></>)
      }
     if(bottom){
       if(addons && addons.length > 0){
         return (renderText())
       }
       return (<></>)
     }else{
       if(!addons || addons.length === 0){
         return (renderText())
       }
       return (<></>)
     }
    }

    const isOneTime  = (price) => {
      if(price && price.length===1){
        return true
      }
      return false
    }

    const hasAddon = !(addons && addons.length > 0)
    if (productAttributes) {
      const { price } = productAttributes
      return (<div className='of-cart-item'>
        <div className='of-cart-item__row of-cart-item__row--product lines-border-1-100'>
          <div className='of-cart-item__wrapper'>
            <div className='of-cart-item__left'>
              {renderIcon(productConfig)}
              <div className='of-cart-item__product-name text-font-1-100'>{getProductName()}</div>
              <div className='of-cart-item__domain-name text-font-3-100'>{getDomainName()}</div>
            </div>
            <div className='of-cart-item__right'>
              <div className='of-cart-item__price'>{renderPrice(service_type, cartItem, price, billing_cycle_id, hasAddon)}</div>
              {renderFirstInvoiceInfo()}
            </div>
          </div>
          {renderConfigs()}
          {renderAddons()}
          {renderQuantity()}
          {renderTotal()}
          <div className={`of-cart-item__wrapper of-cart-item__wrapper--cycle${isOneTime(price)?' of-cart-item__wrapper--one-time':''}`}>
            <div className='of-cart-item__left'>
              <CartBillingCycleDropdown productConfig={productConfig} cartItem={cartItem}/>
            </div>
            <div className='of-cart-item__right'>
              <EditOptions cartItem={cartItem} productConfig={productConfig}/>
            </div>
          </div>
        </div>
      </div>)
    }
    return (<></>)
  }
}

export const getConfigurationListHaveDomainName = (configurations) =>{
  const hosting = getFilteredConfigurationList(SHARED_HOSTING_TYPE,configurations)
  const gsuite = getFilteredConfigurationList(GSUITE_TYPE,configurations)
  let array = []
  if(hosting && hosting.length){
    array = array.concat(hosting)
  }
  if(gsuite && gsuite.length){
    array = array.concat(gsuite)
  }
  return array
}
